export default __webpack_public_path__ + "static/media/icona-calavera-blau.16bf1c87.svg";